export function getDataFromForm(collection,viewConfig,values) {
    let data={};
    viewConfig.fieldList.forEach(field => {
        data[field.field]=values[field.field];
    });
    if (viewConfig.computedFields) {
        viewConfig.computedFields.forEach(fieldTrasformation => {
            data[fieldTrasformation.field]=applyTrasformation(values,fieldTrasformation);
        });
    }
    return data;
}
export function updatedComputedData(collection,item,computedFields,data) {
    try {
    if (computedFields) {
        computedFields.forEach(fieldTrasformation => {
           
                data[fieldTrasformation.field]=applyTrasformation(data,fieldTrasformation);
        });
    }
    } catch (e) {
    }
    return data;
}

export function applyTrasformation(obj,fieldTrasformation) {
    let value;
    if (fieldTrasformation.onlyIfEmptyOrNull===true && obj[fieldTrasformation.field]!=null && obj[fieldTrasformation.field]!=="")
        return;
    switch (fieldTrasformation.type) {
        case "valueFunction":
            let args=[];
            if (fieldTrasformation.args) {
                fieldTrasformation.args.forEach(arg => {
                    args.push(getSourceData(arg,obj));
                });
            }
            const source=getSourceData(fieldTrasformation.source,obj);
            value= source[fieldTrasformation.function](...args);
            break;
        case "eval":
            let sources;
            if (!Array.isArray(fieldTrasformation.source))
                sources=[fieldTrasformation.source];
            else sources=fieldTrasformation.source;
            let sourcesData=[];
            sources.forEach(sourceField => {
                sourcesData.push(getSourceData(sourceField,obj));
            });
            let functionStr=fieldTrasformation.function;
            for (let i=0;i<sourcesData.length;i++) {
                functionStr=functionStr.replace("%"+(i+1)+"%",sourcesData[i]);
            }
            value=eval(functionStr);
            break;
        case "value":
            value= fieldTrasformation.value;
            break;
        case "function":
            value= fieldTrasformation.function(obj[fieldTrasformation.source]);
            break;
        default:
            break;
    }
    return value;
}

function getSourceData(source,obj) {
    if (typeof(source)=="string")
        return obj[source];
    if (source.type==="field")                
        return obj[source.value];                    
    else
        return source.value;
}